import BlockTypes from '../../../types/BlockTypes';
export default function moveToCellBelow(editor) {
  var tableId = editor.getCurrentTableId() || editor.value.document.getNextBlock(editor.value.endBlock.key).getIn(['data', 'tableId']);
  var cells = editor.getTableCells(tableId);
  var nextCell = editor.getCellBelow(editor.value.focusBlock);

  if (nextCell) {
    return editor.moveTo(nextCell.getFirstText().key);
  } else {
    var nextBlock = editor.value.document.getNextBlock(cells.last().key);

    if (nextBlock) {
      return editor.moveTo(nextBlock.getFirstText().key);
    } else {
      return editor.moveTo(cells.last().getFirstText().key).moveToEndOfText().insertBlock(BlockTypes.UNSTYLED);
    }
  }
}